import styled from 'styled-components';

export const SettingStyle = styled.div`
  width: 100%;
  min-height: calc(100vh - 145px);
  font-size: 16px;
  line-height: 20px;
  position: relative;
  display: flex;
  flex-direction: column;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    h1 {
      margin: 0;
      font-weight: 800;
    }

    .btn-menu {
      flex-shrink: 0;
      width: 40px;
      font-size: 30px;
      line-height: 1;
      padding: 5px 5px 0;
      border-radius: 5px;
      background: var(--primary);

      @media (min-width: 992px) {
        display: none;
      }
    }
  }
`;

export const TabsWrap = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  gap: 20px;

  .tab-btns {
    position: fixed;
    left: 0;
    flex-shrink: 0;
    width: 280px;
    padding: 10px 15px;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: #cdcdcd;
    border-radius: 0 10px 10px 0;
    transition: all ease-in-out 0.4s;
    transform: translateX(-350px);
    background: var(--white);
    z-index: 3;

    &.show {
      transform: translateX(0);
    }

    @media (min-width: 992px) {
      width: 240px;
      transform: none;
      position: static;
      border-radius: 0;
      padding: 0 10px 0 0;
      border-width: 0 1px 0 0;
    }

    .holder {
      width: 100%;
      margin-bottom: 25px;
    }

    .subtitle {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      color: var(--light-gray);
      text-transform: capitalize;
      margin-bottom: 10px;
    }

    .btn {
      display: block;
      width: 100%;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      text-align: left;
      padding: 12px;
      border-radius: 8px;
      margin: 0 0 3px;

      &:hover,
      &.active {
        background: var(--gray-100);
      }
    }
  }

  /* button {
    margin-bottom: 20px;
    font-weight: 700;
    padding: 15px 10px;
    color: var(--text-color);
  } */

  .tab-content {
    flex-grow: 1;
  }
`;
